(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name adminCrewBatchers.factory:CrewBatchFactory
     *
     * @description
     *
     */
    angular
        .module('missingSignIn')
        .factory('MissingSignInFactory', MissingSignInFactory);

    function MissingSignInFactory() {

        function SearchCriteriaDTO() {
            this.fromDate = null;
            this.toDate = null;
            this.crewType = null;
            this.crewBase = null;
            this.status = null;
            this.crewId = null;
        }


		function MissingSignIn() {
			this.flightNumber = null;
			this.name = null;
			this.minutesAfterExpire  = null;
			this.crewId  = null;
			this.crewScheduleBlockId  = null;
			this.checkInDate = null;
			this.checkInTime = null;
			this.firstFlightDate = null;
			this.isLegal = null;
		}

		function MissingSignOut() {
			this.flightNumber = null;
			this.name = null;
			this.minutesAfterExpire  = null;
			this.crewId  = null;
			this.crewScheduleBlockId  = null;
			this.checkOutDate = null;
			this.checkOutTime = null;
			this.firstFlightDate = null;
			this.allowSubmitFlightReport = null;
		}


		function SignInRequest(){
			this.signInDate = null;
			this.signInTime = null;
			this.crewScheduleBlockId  = null;
			this.comment = null;
			this.legal = null;
		}

		function SignOutRequest(){
			this.signOutDate = null;
			this.signOutTime = null;
			this.crewScheduleBlockId  = null;
			this.comment = null;
		}

		function FlightReportActivateRequest(){
			this.crewScheduleBlockId = null;
			this.deadlineMinutes =null;
			this.comment = null;
		}


        function GetSearchRequest() {
            return new SearchCriteriaDTO() ;
        }

        function FormateMissingSignInData(dataList){
        	var formattedList = [];
            angular.forEach(dataList, function (missingSignIn) {
                formattedList.push(FormattedMissingSignIn(missingSignIn))
            });
            return formattedList;
        }

        function FormattedMissingSignIn(data){
        	 var missingSignIn =  new MissingSignIn();
        	 missingSignIn.flightNumber = formatFlightNumber(data.flightNumber);
        	 missingSignIn.name = data.name;
        	 missingSignIn.minutesAfterExpire =  populateTimeFromMinutes(data.minutesAfterExpire)+ " No Sign In" ;
        	 missingSignIn.crewScheduleBlockId = data.crewScheduleBlockId;
        	 missingSignIn.crewId = data.crewId;
        	 missingSignIn.checkInDate = data.checkInDate;
        	 missingSignIn.checkInTime = data.checkInTime;
        	 missingSignIn.firstFlightDate = data.firstFlightDate;
        	 missingSignIn.isLegal = data.legal;
             return missingSignIn;
        }

        function FormateMissingSignOutData(dataList){
        	var formattedList = [];
            angular.forEach(dataList, function (missingSignOut) {
                formattedList.push(FormattedMissingSignOut(missingSignOut))
            });
            return formattedList;
        }

        function FormattedMissingSignOut(data){
        	 var missingSignOut =  new MissingSignOut();
        	 missingSignOut.flightNumber = formatFlightNumber(data.flightNumber);
        	 missingSignOut.name = data.name;
        	 missingSignOut.minutesAfterExpire =  populateTimeFromMinutes(data.minutesAfterExpire)+ " No Sign Out" ;
        	 missingSignOut.crewScheduleBlockId = data.crewScheduleBlockId;
        	 missingSignOut.crewId = data.crewId;
        	 missingSignOut.checkOutDate = data.checkOutDate;
        	 missingSignOut.checkOutTime = data.checkOutTime;
        	 missingSignOut.firstFlightDate = data.firstFlightDate;
        	 missingSignOut.allowSubmitFlightReport = data.allowSubmitFlightReport;

             return missingSignOut;
        }


        function formatFlightNumber(flightNumber){
        	var charCount = flightNumber.length;

        	if(charCount > 11){
        		return [flightNumber.slice(0, 12), ' ', flightNumber.slice(12)].join('');
        	}else{
        		return flightNumber;
        	}

        }


        function populateTimeFromMinutes(minutes){

        	var numberOfDays = Math.floor(minutes / 1440);

        	var remainTime = minutes % 1440;

        	var numberOfHours = Math.floor(remainTime / 60);

        	var numberOfMinutes = Math.floor(remainTime % 60);

        	var strTime = ("-")+(numberOfDays===0 ? "": ( numberOfDays+"d " ) ) +
        	 (numberOfDays===0 && numberOfHours ===0 ? "" : ( numberOfHours+"h " ) )+
        	 (numberOfMinutes+"m");

        	return strTime;

        }

        function PopulateSignInRequest(data){
        	var request = new SignInRequest();
        	request.signInDate = data.signInDate;
        	request.signInTime = data.signInTime;
        	request.crewScheduleBlockId  = data.crewScheduleBlockId;
        	request.comment = data.comment;
        	request.legal = data.isLegal;
        	return request;
        }

        function PopulateSignOutRequest(data){
        	var request = new SignOutRequest();
        	request.signOutDate = data.signOutDate;
        	request.signOutTime = data.signOutTime;
        	request.crewScheduleBlockId  = data.crewScheduleBlockId;
        	request.comment = data.comment;
        	return request;
        }

        function PopulateReportActivateRequest(data){
        	var timeArray = data.deadLine.split(":");

        	var hours = parseInt(timeArray[0]);
        	var minutes = parseInt(timeArray[1]);

        	var request = new FlightReportActivateRequest();
        	request.crewScheduleBlockId = data.crewScheduleBlockId;
        	request.deadlineMinutes = ( hours * 60 ) + minutes ;
        	request.comment = data.comment;
        	return request;
        }

        function PopulateDeadlineExtendRequest(data){

        	var timeArray = data.extendtime.split(":");

        	var hours = parseInt(timeArray[0]);
        	var minutes = parseInt(timeArray[1]);

        	var request = new FlightReportActivateRequest();
        	request.crewScheduleBlockId = data.crewScheduleBlockId;
        	request.deadlineMinutes = ( hours * 60 ) + minutes ;
        	return request;
        }

        return {
              getSearchRequest: GetSearchRequest,
              formateMissingSignInData: FormateMissingSignInData,
              populateSignInRequest:PopulateSignInRequest,
              formateMissingSignOutData: FormateMissingSignOutData,
              populateSignOutRequest:PopulateSignOutRequest,
              populateReportActivateRequest:PopulateReportActivateRequest,
              populateDeadlineExtendRequest : PopulateDeadlineExtendRequest
        }
    }
})();
